import React from 'react'
import './ErrorPage.scss'

const ErrorPage = ({title, subtitle, showIcon = true}) => {
    const isUnauthorized = title === "Not Authorized"
    
    return (
        <div className="error-page">
            <div className="error-content">
                {showIcon && (
                    <div className="error-icon">
                        {isUnauthorized ? (
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z" fill="currentColor"/>
                            </svg>
                        ) : (
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="currentColor"/>
                            </svg>
                        )}
                    </div>
                )}
                
                <div className="error-text">
                    <h1 className="error-title">
                        {title || "Oops something went wrong"}
                    </h1>
                    
                    {subtitle && (
                        <p className="error-subtitle">
                            {subtitle}
                        </p>
                    )}
                    
                    {isUnauthorized && (
                        <p className="error-subtitle">
                            You don't have permission to access this area. Please contact an administrator if you believe this is an error.
                        </p>
                    )}
                </div>
                
                {isUnauthorized && (
                    <div className="error-actions">
                        <button 
                            className="btn-secondary"
                            onClick={() => window.history.back()}
                        >
                            Go Back
                        </button>
                        <button 
                            className="btn-primary"
                            onClick={() => window.location.href = '/explore'}
                        >
                            Go Home
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ErrorPage